import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import CircleLoader from "react-spinners/CircleLoader";
import AuthenticatedRouter from "./AuthenticatedRouter";
import AuthorizedRoute from "./AuthorizedRoute";
import NotFound from '../../NotFound/NotFound';
const routes = [
    {
        path: '/login',
        Component: lazy(() => import('../../../page/Login/Login')),
        exact: true,
    },
    {
        path: '/signUp',
        Component: lazy(() => import('../../../page/Signup/Signup')),
        exact: true,
    }
]

const AuthRouter = () => {

    return (
        <div>
            <Suspense fallback={<div className="loader">
                <CircleLoader size={50} color="#157160" />
            </div>}>
                <Switch>
                    {
                        localStorage.getItem('Token') === null ? (<>
                            {
                                routes.map((route, idx) => (
                                    <Route exact={route.exact} key={idx} path={`${route.path}`}>
                                        <route.Component />
                                    </Route>
                                ))
                            }
                            <Route component={AuthenticatedRouter} />
                        </>) : (<><Route component={AuthenticatedRouter} /></>)
                    }
                </Switch>
            </Suspense>
        </div>
    );
};

export default AuthRouter;